import HeroSection from "./HeroSection";
import Banner from "../../Assets/Images/contact_banner.png";
import axios from "../../axios";
import { useState } from "react";

function Contact() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState("");
  const [statusType, setStatusType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // Clear error when typing
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.firstName.trim())
      newErrors.firstName = "First Name is required.";
    if (!formData.lastName.trim())
      newErrors.lastName = "Last Name is required.";
    if (!formData.phone.trim()) newErrors.phone = "Phone is required.";
    if (!formData.message.trim()) newErrors.message = "Message is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format.";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true); // Start loader

    const fullName = `${formData.firstName} ${formData.lastName}`;

    axios
      .post("/Contact", {
        fullName,
        email: formData.email,
        phone: formData.phone,
        message: formData.message,
      })
      .then((res) => {
        if (res.data === "success") {
          setStatusMessage("Message sent successfully!");
          setStatusType("success");
          setFormData({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            message: "",
          });
          setErrors({});
        } else {
          setStatusMessage("Failed to send message.");
          setStatusType("error");
        }
      })
      .catch(() => {
        setStatusMessage("An error occurred while sending the message.");
        setStatusType("error");
      })
      .finally(() => {
        setIsSubmitting(false); // Stop loader
      });
  };

  return (
    <div className="Contact-page">
      <HeroSection image={Banner} pageTitle="Contact Us" />

      <section className="d-flex flex-column justify-content-center align-items-center text-center">
        <div className="container">
          <h2 className="mb-3">We’d love to hear from you!</h2>
          <p className="fw-light px-lg-5">
            Whether you have inquiries about our services, need assistance with
            event planning, or want to collaborate, feel free to reach out. Our
            team is here to assist you with professionalism and efficiency.
          </p>
        </div>
      </section>

      <section className="contact-form pt-0">
        <div className="container-fluid">
          <div className="row bg-light p-lg-5">
            {/* Contact Info */}
            <div className="col-12 col-md-6 mb-4">
              <h6>Address</h6>
              <p>
                09, Wadala Udyog Bhavan, Naigoan Cross Road,
                <br />
                Wadala, Mumbai 400031, Maharashtra, India
              </p>
              <h6>Phone</h6>
              <p>+91 7039370147</p>
              <h6>Email</h6>
              <p>sales@samsdigital.in</p>
              <h6>Website</h6>
              <p>www.samsdigital.in</p>
            </div>

            {/* Contact Form */}
            <div className="col-12 col-md-6">
              <p className="pb-lg-5 text-center text-lg-start">
                For any queries, fill out the form below, and we’ll get back to
                you as soon as possible. Let’s create something amazing
                together!
              </p>

              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col">
                    <label className="form-label">
                      First Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      className="form-control border-0 border-bottom border-black rounded-0 bg-transparent shadow-none"
                    />
                    {errors.firstName && (
                      <small className="text-danger">{errors.firstName}</small>
                    )}
                  </div>

                  <div className="col">
                    <label className="form-label">
                      Last Name<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      className="form-control border-0 border-bottom border-black rounded-0 bg-transparent shadow-none"
                    />
                    {errors.lastName && (
                      <small className="text-danger">{errors.lastName}</small>
                    )}
                  </div>
                </div>

                <div className="row my-4">
                  <div className="col">
                    <label className="form-label">
                      Phone<span className="text-danger">*</span>
                    </label>
                    {/* <input
                                            type="text"
                                            name="phone"
                                            maxLength={10}
                                            value={formData.phone}
                                            onChange={handleChange}
                                            className="form-control border-0 border-bottom border-black rounded-0 bg-transparent shadow-none"
                                        /> */}
                    <input
                      type="text"
                      name="phone"
                      maxLength={10}
                      value={formData.phone}
                      onChange={(e) => {
                        const numericValue = e.target.value.replace(/\D/g, ""); // Keep only digits
                        setFormData({ ...formData, phone: numericValue });
                        setErrors({ ...errors, phone: "" });
                      }}
                      className="form-control border-0 border-bottom border-black rounded-0 bg-transparent shadow-none"
                    />

                    {errors.phone && (
                      <small className="text-danger">{errors.phone}</small>
                    )}
                  </div>

                  <div className="col">
                    <label className="form-label">
                      Email<span className="text-danger">*</span>
                    </label>
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className="form-control border-0 border-bottom border-black rounded-0 bg-transparent shadow-none"
                    />
                    {errors.email && (
                      <small className="text-danger">{errors.email}</small>
                    )}
                  </div>
                </div>

                <div className="my-4">
                  <label className="form-label">
                    Message<span className="text-danger">*</span>
                  </label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    className="form-control border-0 border-bottom border-black rounded-0 bg-transparent shadow-none"
                    rows="2"></textarea>
                  {errors.message && (
                    <small className="text-danger">{errors.message}</small>
                  )}
                </div>

                {statusMessage && (
                  <div
                    className={`mb-3 fw-medium ${
                      statusType === "success" ? "text-success" : "text-danger"
                    }`}>
                    {statusMessage}
                  </div>
                )}

                {/* <button type="submit" className="btn submit-btn rounded-0 px-3 mb-4 text-black mt-2">
                                    Submit
                                </button> */}
                <button
                  type="submit"
                  className="btn submit-btn rounded-0 px-3 mb-4 text-black mt-2"
                  disabled={isSubmitting}>
                  {isSubmitting ? (
                    <span>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"></span>
                      Sending...
                    </span>
                  ) : (
                    "Submit"
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
